import { gql } from '@apollo/client';

export const GET_CALENDAR_DATA = gql`
  query GetCalendarData($dateRange: DateRange!) {
    getCalendarEvents(dateRange: $dateRange) {
      id
      title
      description
      startTime
      endTime
      location
      color
      repeat
      allDay
    }
  }
`;

export const GET_CALENDAR_DAY_DATA = gql`
  query GetCalendarDayData($dateRange: DateRange!) {
    getDays(dateRange: $dateRange) {
      id
      date
      completedDailies {
        id
      }
      journalEntries {
        id
        content
      }
    }
    getTasks {
      id
      title
      status
      completedAt
    }
    getDailies(activeOnly: true) {
      id
    }
  }
`;

export const CREATE_EVENT = gql`
  mutation CreateEvent($event: CalendarEventInput!) {
    createCalendarEvent(event: $event) {
      id
      title
    }
  }
`;

export const UPDATE_EVENT = gql`
  mutation UpdateEvent($id: ID!, $event: CalendarEventInput!) {
    updateCalendarEvent(id: $id, event: $event) {
      id
      title
    }
  }
`;

export const DELETE_EVENT = gql`
  mutation DeleteEvent($id: ID!) {
    deleteCalendarEvent(id: $id)
  }
`;
